<template>
  <h-button class="vcode" :class="{'with-icon': withIcon}" btn-type="white" 
            @click="sendVCode" 
            :disabled="disabled" 
            :content="btnText"
  >
    <div v-if="withIcon" slot="left" class="icon-get-vcode" ></div>
    <!-- @/assets/img/authentication/icon_get_vcode.png 却少不可点击状态icon-->
  </h-button>
</template>

<script>
import { getVCodeAfter, getVCodeOnlyRegisterUser } from '@/http/usercenter.js'
export default {
  name: 'VcodeButton',
  props: {
    mobile: Number | String,
    content: {
      type: String,
      default: '获取验证码'
    },
    duringSecond: { // 验证码发送间隔时间
      type: Number,
      default: 60
    },
    sendContent: {
      type: String,
      default: '已发送'
    },
    withIcon: {
      type: Boolean,
      default: false
    },
    msgtype: String,
    isLogin: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      disabled: false,
      second: 60,
      flagGVCode: false
    }
  },
  computed: {
    btnText() {
      return this.disabled ? `${this.sendContent}(${this.second}s) `: this.content
    }

  },
  methods: {
    async sendVCode () {
      console.log('click sendcode',this.mobile)
      await this.getVCode()
      if (this.disabled) {
        this.second = 60
        this.timer = setInterval(() => {
          this.second--
          if (this.second === 0) {
            clearInterval(this.timer)
            this.disabled = false
          }
        }, 1000)
      }
    }, 
    async getVCode() {
      const reg = /^1\d{10}$/
      let data = '' // 返回接口数据
      if(reg.test(this.mobile)) {
        console.log('调接口获取验证码')
         const loginParam={
          mobile: this.mobile,
          msgtype: this.msgtype
        }
        // const data = await getVCode(loginParam)
        if(this.isLogin) {
          data = await getVCodeAfter(loginParam)
        } else {
          data = await getVCodeOnlyRegisterUser(loginParam)
        }
        if (data.ret == 0) {
          this.disabled = true // 成功时
          this.$emit('click', data) // 验证码发送成功
        }
      } else {
        if(!this.mobile) {
          this.$message('手机号不能为空')
        } else {
          this.$message('请输入正确的手机号')
        }
      }
    },
  },
  beforeDestroy () {
    clearInterval(this.timmer)
  },
}
</script>

<style lang="less" scoped>
.vcode {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 110px;
      height: 40px;
      background: none;
      border: solid 1px var(--color-high-background);
      border-radius: 4px;
      font-size: 12px;
      font-weight: 600;
      color: var(--color-high-background);
      cursor: pointer;
      &.with-icon {
        min-width: 130px;
      }
      .icon-get-vcode {
        width: 12px;
        height: 16px;
        margin-right: 7px;
        background: url('~@/assets/img/authentication/icon_get_vcode.png');
        background-size: 100% 100%;
      }
      &[disabled] {
        border: 1px solid #858692;
        color: #858692;
      }
      &:active {
        opacity: .5;
      }
    }
</style>